module.exports = __webpack_public_path__ + "static/media/bruce1.f3dd5620.mp3";